import { usePermissionChecker } from "./usePermissionChecker";

export function useCanManageDMS(): boolean {
  const { hasSomePermissions } = usePermissionChecker();
  return hasSomePermissions([
    "Fixhub.DocNodeManagementSystem.ManageContents",
    "Fixhub.DocNodeManagementSystem.ManageLibraries",
    "Fixhub.DocNodeManagementSystem.SuperAdmin",
  ]);
}
